import { takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from 'src/api/instance';
import { notification } from 'antd';
import { createIntl } from 'react-intl';
import ruLocales from 'src/locales/ru.json';

const intl = createIntl({ messages: ruLocales, locale: 'ru' });

function* rootNotificationSaga() {
  yield takeEvery('*', watchRejectedActions);
}

function watchRejectedActions(action: PayloadAction<ApiError>) {
  const { type, payload } = action;
  if (type.includes('/rejected')) {
    notification.error({
      description: intl.formatMessage({ id: payload.code }),
      message: 'Ошибка сервера',
    });
  }
}

export default rootNotificationSaga;
